import React from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import ScreenLogService from "../common/ScreenLogService";
import styles from './ScreenLogCard.module.scss';

interface ScreenLogCardState {
    visible: boolean;
    text: string;
}

/**
 * Card controlled by ScreenLogService to print logs on screen.
 *
 * Place an instance at the top level of the app. It needs no props:
 * it is opened by calling ScreenLogService.open(text).
 */
class ScreenLogCard extends React.Component<object, ScreenLogCardState> {

    constructor(props: object) {
        super(props);

        this.state = {
            visible: false,
            text: '',
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount(): void {
        // Register the handler after mount, so that handleOpen's setState is
        // applied on an already-mounted component (avoids the constructor no-op).
        ScreenLogService.setHandler(this.handleOpen);
    }

    handleOpen(text: string): void {
        this.setState({ visible: true, text });
    }

    handleClose(): void {
        this.setState({ visible: false });
    }

    render() {
        if (!this.state.visible) {
            return null;
        }

        return (
            <div className={styles.card}>
                <CancelIcon className={styles.closeButton} onClick={this.handleClose} />
                <pre className={styles.content}>{String(this.state.text)}</pre>
            </div>
        );
    }
}

export default ScreenLogCard;
